import { render, staticRenderFns } from "./PCBusiness.vue?vue&type=template&id=5a633e93&scoped=true"
import script from "./PCBusiness.vue?vue&type=script&lang=js"
export * from "./PCBusiness.vue?vue&type=script&lang=js"
import style0 from "./PCBusiness.vue?vue&type=style&index=0&id=5a633e93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a633e93",
  null
  
)

export default component.exports